export const PARCEL_PROXY = 'https://nlr.beitzanddaigh.com/parcels/parcels.php';
export const PARCEL_MINSCALE = 5000;

export const SMALL_SCALE = 500000;
export const REGION_SCALE = 3000000;
export const STATEWIDE_SCALE = 5000000;

export const LAND_CHAR_TITLE = 'Land Characteristics';
export const POLLUTION_TITLE = 'Pollution';
export const SPECIES_TITLE = 'Species';
export const WETLANDS_TITLE = 'Wetlands';

export const WIDGET_BUTTON_CLASS = { className: 'd-flex align-items-center text-primary justify-content-center p-2 bg-white border-0 rounded-0' };
